import { render, staticRenderFns } from "./T3.vue?vue&type=template&id=0d8e825a&"
import script from "./T3.vue?vue&type=script&lang=js&"
export * from "./T3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports